import { render } from "./BaseSelectionCard.vue?vue&type=template&id=39409f9c&ts=true"
import script from "./BaseSelectionCard.vue?vue&type=script&lang=ts"
export * from "./BaseSelectionCard.vue?vue&type=script&lang=ts"

import "./BaseSelectionCard.vue?vue&type=style&index=0&id=39409f9c&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__